<template>
  <div>
    <b-modal id="select-accountain-action" centered hide-footer>
      <template #modal-header="">
        <h5>Kế toán thao tác</h5>
        <b-button size="sm" variant="light" @click="closeModal()"> x </b-button>
      </template>
      <div class="button">
        <b-button @click="approveKpi" class="b-button" variant="outline-secondary"
          >Duyệt KPI</b-button
        >
      </div>
      <div class="button">
        <b-button @click="uploadStatusFile" class="b-button" variant="outline-secondary"
          >Upload trạng thái file hợp đồng</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    methods: {
      approveKpi() {
        this.$emit('approveKpi')
      },
      uploadStatusFile() {
        this.$emit('uploadStatusFile')
      },
      closeModal() {
        this.$emit('closeModal')
      },
    },
  }
</script>

<style scoped>
  .button {
    display: flex;
    justify-content: center;
    margin-top: 5px;
  }
  .b-button {
    min-width: 225px;
  }
</style>
